import React, { useState } from "react";
import { navigate } from "@reach/router";

import { ResourceForm } from "../ResourceForm";
import { addResource } from "../../actions/companyActions";
import { showToast } from "utils/helpers";
import { useCurrentCompanyId } from "hooks/auth";
import { useDispatch } from "react-redux";

const baseInitialValues = {
	company_id: "",
	first_name: "",
	last_name: "",
	email: "",
	position: "",
	experience: "",
	roles: [1],
	location: "",
	sector_ids: [],
	projects_completed: [],
	disciplines: [{ expertise: "", disciplines: [] }],
	resume: [],
	// These metadata fields are required for the form to track default, backend IDs, and removal state for each resume file
	resume_files: [],
	resume_files_is_default: {},
	resume_files_id: {},
	resume_files_is_remove: {},
};

const projectsDataStructure = {
	name: "",
	role: "",
	sector_id: [],
	location: "",
	value: "",
};

export const AddResource = ({
	company,
}) => {
	const currentCompanyId = useCurrentCompanyId();
	const dispatch = useDispatch();
	const [isSubmitting, setIsSubmitting] = useState(false);

	const initialValues = { ...baseInitialValues, company_id: currentCompanyId };

	const handleSubmit = async (values, { setErrors, setStatus }) => {
		try {
			setIsSubmitting(true);
			await dispatch(addResource(values, setErrors, setStatus));
			navigate("../resources");
			showToast("Resource added successfully.", "Success", true);
		} catch (e) {
			if (!(e instanceof Error)) {
				const emailError = e.errors?.email[0];
				setStatus(e.message);
				setErrors(emailError ? { email: emailError } : e.message);
				showToast(e.message, "Error");
			} else {
				const msg = "Unexpected Error occurred";
				setStatus(msg);
				setErrors(msg);
				showToast(msg, "Error");
			}
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<ResourceForm
			initialValues={initialValues}
			isSubmitting={isSubmitting}
			handleSubmit={handleSubmit}
			projectsDataStructure={projectsDataStructure}
		/>
	);
};
